import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
}

// Straight left arrow (tabler:arrow-left) — the leading glyph on the gradient-text "BACK TO RISK
// INTEL" secondary CTA (ticket 7127, screen 20). Brand-gradient stroked to match the label.
export const ArrowLeftSvg: React.FC<Props> = ({ size = 22, style, className }) => {
  const colors = useStateSelector((state) => state.theme.colors);
  const id = `arrowleft_${Math.random().toString(36).slice(2)}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M17.4167 11H4.58333M4.58333 11L10.0833 16.5M4.58333 11L10.0833 5.5"
        stroke={`url(#${id})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient id={id} x1="4.58" y1="5.5" x2="17.42" y2="16.5" gradientUnits="userSpaceOnUse">
          <stop stopColor={colors.gp1} />
          <stop offset="1" stopColor={colors.gp2} />
        </linearGradient>
      </defs>
    </svg>
  );
};
